/**
 * Loading state for Moderation Topic Detail Page
 */

import { HeroBackground } from '@core/components/HeroBackground';
import { ModerationTopicDetailHeaderSection } from '@moderation/components/ModerationTopicDetailHeaderSection';
import { Text } from '@soteria/design-system-ve';

import * as styles from '../ModerationTopicDetailPage.css';

import * as loadingStyles from './ModerationTopicDetailLoadingState.css';

interface ModerationTopicDetailLoadingStateProps {
  communityId: string;
  topicId: string;
}

export function ModerationTopicDetailLoadingState({ communityId: _communityId, topicId: _topicId }: ModerationTopicDetailLoadingStateProps) {
  return (
    <div>
      <HeroBackground imageUrl={undefined} />
      <ModerationTopicDetailHeaderSection isLoading community={null} topic={null} />
      <div className={styles.contentSection}>
        <div className={styles.contentContainer}>
          <div className={loadingStyles.container}>
            <Text>Loading topic details...</Text>
          </div>
        </div>
      </div>
    </div>
  );
}
